export default "__VITE_ASSET__BDqpvvK6__"